<template>
    <div id="info-box">
        <div class="info-container">
            <div v-if="!expanded" @click="toggleExpand" class="info-i">
                i
            </div>
            <div v-else>
                <div @click="toggleExpand" class="info-x">
                    ✖
                </div>
                <p class="info-title">
                    {{description.title}}
                </p>
                <p class="info-text">
                    {{description.text}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'info-box',
  data () {
    return {
      expanded: false
    }
  },
  props: ['description'],
  methods: {
    toggleExpand () {
      if (this.expanded) {
        document.getElementsByClassName('info-container')[0].className = 'info-container'
        setTimeout(() => {
          this.expanded = false
        }, 300)
      } else {
        this.expanded = true
        document.getElementsByClassName('info-container')[0].classList.add('expand')
      }
    }
  }
}
</script>
<style scoped>
#info-box{
    position: fixed;
    left: 16px;
    bottom: 16px;
    z-index: 400;
    text-align: left;
    margin: 0;
}
.info-container{
    background: rgba(12, 12, 15, 0.9);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    max-height: 32px;
    max-width: 32px;
    border: 1px solid rgba(224, 31, 40, 0.55);
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.35s ease;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}
.info-container.expand{
    padding: 14px;
    border-radius: var(--sl-radius);
    max-height: 420px;
    max-width: 240px;
    cursor: default;
}
.info-i{
    width: 30px;
    height: 30px;
    font-family: var(--sl-font-cond);
    font-size: 17px;
    font-weight: 800;
    line-height: 30px;
    text-align: center;
    color: var(--sl-red);
    cursor: pointer;
}
.info-x{
    float: right;
    font-size: 12px;
    line-height: 1;
    color: var(--sl-dim);
    cursor: pointer;
}
.info-x:hover{
    color: #fff;
}
.info-title{
    font-family: var(--sl-font-cond);
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    text-align: left;
    margin: 0 0 6px;
}
.info-text{
    width: 210px;
    margin: 0;
    font-size: 13.5px;
    line-height: 1.45;
    color: #b6b6be;
}
</style>


// WEBPACK FOOTER //
// src/components/Info-Box.vue